import React, { useState } from "react";
import "./Disclaimer_Modal.css";
import { Form, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Disclaimer_Modal = (props) => {
  const navigate = useNavigate();

  return (
    <>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="Disclaimer_Modal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Investment Policy
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="main_content_div">
            <p className="title_text">
              Investments are subject to market risks, read all scheme related
              documents carefully before investing
            </p>

            <div className="policy_div">
              <p className="point_text">
                <span className="bold_text">Risk Warning : </span>Trading
                foreign exchange (Forex) involves significant risk and may not
                be suitable for all investors. The high degree of leverage can
                work against you as well as for you. Before deciding to trade
                Forex, you should carefully consider your investment objectives,
                level of experience, and risk appetite.
              </p>

              <p className="point_text">
                <span className="bold_text">No Guarantees: </span> There is no
                guarantee of profit in Forex trading. Past performance is not
                indicative of future results. Market conditions can change
                rapidly, and losses may exceed your initial investment.
              </p>

              <p className="point_text">
                <span className="bold_text">Educational Purpose Only:</span> Any
                information, analysis, or content provided is for educational
                and informational purposes only and does not constitute
                financial advice, investment recommendations, or a solicitation
                to buy or sell any financial instrument.
              </p>

              <p className="point_text">
                <span className="bold_text">Independent Advice: </span> You
                should seek independent financial advice from a qualified
                professional before making any trading decisions. You are solely
                responsible for your financial decisions and trades.
              </p>

              <p className="point_text">
                <span className="bold_text">Limitation of Liability: </span> The
                publisher, website owner, or content provider accepts no
                liability for any direct, indirect, or consequential loss or
                damage incurred as a result of reliance on the information
                provided.
              </p>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Disclaimer_Modal;
